import React from "react";

const FinanceiroPage = () => {
    return <div>Financeiro</div>
}

export default FinanceiroPage;